import type { SxProps, Theme } from '@mui/material/styles'

/** Figma 5181:9978 / 5181:10123 — Confirm Your Reward modal */
export const CONFIRM_REWARD_MODAL_WIDTH_PX = 520

export const confirmRewardModalBackdropSx = {
  bgcolor: 'rgba(0, 0, 0, 0.65)',
} as const

export const confirmRewardModalPaperSx = {
  width: '100%',
  maxWidth: { xs: 'calc(100vw - 32px)', sm: CONFIRM_REWARD_MODAL_WIDTH_PX },
  borderRadius: '16px',
  boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
  bgcolor: '#FFFFFF',
  m: 2,
  overflow: 'hidden',
} as const

export const confirmRewardModalContentSx = {
  px: { xs: 2, md: '28px' },
  pt: { xs: 2, md: '28px' },
  pb: { xs: 2, md: '28px' },
  boxSizing: 'border-box',
} as const

export const confirmRewardModalHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  mb: '20px',
  minHeight: '32px',
} as const

export const confirmRewardModalTitleSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '30px',
  color: '#0D1B2A',
  textAlign: 'left',
} as const

export const confirmRewardModalCloseButtonSx = {
  width: 32,
  height: 32,
  flexShrink: 0,
  bgcolor: '#F4F7FA',
  borderRadius: '8px',
  color: '#0D1B2A',
  '&:hover': { bgcolor: '#E8EDF2' },
} as const

export const confirmRewardBrandStripSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  bgcolor: '#F4F7FA',
  borderRadius: '12px',
  px: '18px',
  py: '14px',
  minHeight: '72px',
  boxSizing: 'border-box',
  mb: '16px',
} as const

export const confirmRewardBrandLogoSx = {
  width: 44,
  height: 44,
  borderRadius: '10px',
  border: '1px solid #E4E9F0',
  boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.08)',
  objectFit: 'cover' as const,
  flexShrink: 0,
} as const

export const confirmRewardBrandLogoPlaceholderSx = {
  width: 44,
  height: 44,
  borderRadius: '10px',
  border: '1px solid #E4E9F0',
  boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.08)',
  bgcolor: '#FFFFFF',
  flexShrink: 0,
} as const

export const confirmRewardBrandNameSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '17px',
  lineHeight: '25.5px',
  color: '#0D1B2A',
  minWidth: 0,
} as const

export const confirmRewardBalanceRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  mb: '16px',
  color: '#008CD0',
} as const

export const confirmRewardBalanceTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  color: '#008CD0',
} as const

export const confirmRewardAmountLabelSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  color: '#0D1B2A',
  mb: '8px',
  display: 'block',
} as const

export const confirmRewardAmountFieldSx: SxProps<Theme> = {
  mb: '8px',
  '& .MuiOutlinedInput-root': {
    height: '52px',
    borderRadius: '10px',
    bgcolor: '#FFFFFF',
    '& fieldset': {
      borderWidth: '2px',
      borderColor: '#E5E7EB',
    },
    '&:hover fieldset': {
      borderColor: '#E5E7EB',
    },
    '&.Mui-focused fieldset': {
      borderWidth: '2px',
      borderColor: '#008CD0',
    },
    '&.Mui-error fieldset': {
      borderColor: '#DC2626',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: '"Inter", sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#0D1B2A',
    py: 0,
    px: '16px',
    '&::placeholder': {
      color: 'rgba(13, 27, 42, 0.5)',
      opacity: 1,
    },
  },
  '& .MuiFormHelperText-root': {
    display: 'none',
  },
}

export const confirmRewardAmountHintTextSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  color: '#A0ABBF',
  display: 'block',
  mb: '24px',
} as const

export const confirmRewardAmountErrorSx = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '12px',
  lineHeight: '18px',
  color: '#DC2626',
  mb: '24px',
  display: 'block',
} as const

export const confirmRewardRedeemButtonSx: SxProps<Theme> = {
  height: '52px',
  borderRadius: '12px',
  textTransform: 'none',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  boxShadow: 'none',
  mb: '12px',
  bgcolor: '#008CD0',
  '&:hover': { bgcolor: '#007AB8', boxShadow: 'none' },
  '&.Mui-disabled': {
    bgcolor: '#94A3B8',
    color: '#FFFFFF',
  },
}

export const confirmRewardCancelButtonSx = {
  height: '44px',
  textTransform: 'none',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '15px',
  lineHeight: '22.5px',
  color: '#64748B',
  '&:hover': {
    bgcolor: 'transparent',
    color: '#475569',
  },
} as const
